import { BareActionContext } from 'vuex-typex'
import { FeedState } from '@/store/feed/state'
import { RootState } from '@/store'
import feedStore from '@/store/feed/feed-store'
import statementStore from '@/store/statement/statement-store'

export default async function editCommentStatements(context: BareActionContext<FeedState, RootState>)
{
    feedStore.commitSetFeedType({ type: 'comment-statement-edit', columns: 2 })
    statementStore.dispatchSetStatementQuery()

    return
}
